export default {
  "changelog.title": "Change History",
  "changelog.operation.insert": "Created",
  "changelog.operation.update": "Modified",
  "changelog.operation.delete": "Deleted",
  "changelog.no_changes": "No changes recorded",
  "changelog.changed_fields": "Changed fields",
  "changelog.unknown_user": "Unknown user",
};
